import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Logo from "./Assets/Logo.svg";

export default function Header() {
    const location = useLocation();
    const [activeLink, setActiveLink] = useState("");

    // Update active link based on current path
    useEffect(() => {
        const path = location.pathname;
        if (path === "/") setActiveLink("Strategy");
        else if (path === "/about") setActiveLink("About");
        else if (path === "/news") setActiveLink("News");
    }, [location]);

    const handleLinkClick = (link) => {
        setActiveLink(link);
    };

    return (
        <header className="bg-white top-0 z-50 w-full p-2 sm:p-4 md:p-5 topLine">
            <nav className="container mx-auto px-2 sm:px-4">
                {/* Flex container */}
                <div className="flex flex-cols  items-center justify-between gap-4 sm:gap-0">

                    {/* Logo section */}
                    <div className="flex items-center space-x-2 sm:space-x-3 md:space-x-4">
                        <img
                            src={Logo}
                            alt="Logo"
                            className="h-8 sm:h-12 md:h-16 lg:h-20 xl:h-24 w-auto"
                        />
                        <div>
                            <p className="xl:text-7xl lg:text-6xl md:text-5xl sm:text-3xl text-2xl font-medium">
                                Overfunded
                            </p>
                            <p className="xl:text-7xl lg:text-6xl md:text-5xl sm:text-3xl text-2xl font-medium">
                                Fund
                            </p>
                        </div>
                    </div>

                    {/* Navigation Links */}
                    <ul className="flex space-x-4 sm:space-x-6 md:space-x-8 lg:space-x-10 xl:space-x-12 
                    xl:text-7xl lg:text-6xl md:text-5xl sm:text-4xl text-3xl">
                        <li>
                            <Link
                                to="/"
                                onClick={() => handleLinkClick("Strategy")}
                                className={`
                                        
                                        hover:text-green-600 transition duration-300
                                        ${activeLink === "Strategy" ?
                                        "active-strategy-bg" :
                                        ""}
            `}
                            >
                                Strategy
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/about"
                                onClick={() => handleLinkClick("About")}
                                className={`
                                        
                                        hover:text-green-600 transition duration-300
                                        ${activeLink === "About" ?
                                        "active-about-bg" :
                                        ""}
            `}
                            >
                                About
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/news"
                                onClick={() => handleLinkClick("News")}
                                className={`
                                        
                                        hover:text-green-600 transition duration-300
                                        ${activeLink === "News" ?
                                        "active-news-bg" :
                                        ""}
            `}
                            >
                                News
                            </Link>
                        </li>
                    </ul>
                </div>
            </nav>
        </header>
    );
}